export const financeiro = [
  {
    text: 'Análise',
    value: 'descricao_analise',
    styleHeader: {
      minWidth: '30%'
    }
  },
  {
    text: "Total de Sku's",
    value: 'qtde_produtos',
    styleHeader: {
      textAlign: 'center'
    }
  },
  {
    text: "Valor",
    value: 'estoque_em_preco_custo',
    style: {
      borderLeft: '1px solid #cecece',
      textAlign: 'center'
    }
  },
  {
    text: "Cobertura",
    value: 'cobertura_estoque',
    style: { borderRight: '1px solid #cecece',
      textAlign: 'center'
    }
  },
  {
    text: "Valor",
    value: 'estoque_ideal_systock_em_preco_custo',
    style: {
      textAlign: 'center'
    }
  },
  {
    text: "Cobertura",
    value: 'cobertura_ideal_systock',
    style: {
      textAlign: 'center'
    }
  },
  {
    text: "Excesso",
    value: 'excesso_atual_em_preco_custo',
    style: {
      borderRight: '1px solid #cecece',
      textAlign: 'center',
      background: '#fdebeb !important',
    }
  },
  {
    text: "Valor",
    value: 'estoque_parametrizado_em_preco_custo',
    style: {
      textAlign: 'center'
    }
  },
  {
    text: "Cobertura",
    value: 'cobertura_parametrizavel',
    style: {
      textAlign: 'center'
    }
  },
  {
    text: "Excesso",
    value: 'excesso_acima_do_parametrizado_em_preco_custo',
    style: {
      textAlign: 'center',
      background: '#fdebeb !important',
    }
  },
];

export const quantitativo = [
  {
    text: 'Análise',
    value: 'descricao_analise',
    styleHeader: {
      minWidth: '30%'
    }
  },
  {
    text: "Total de Sku's",
    value: 'qtde_produtos',
    styleHeader: {
      textAlign: 'center'
    }
  },
  {
    text: "Valor",
    value: 'estoque',
    style: {
      borderLeft: '1px solid #cecece',
      textAlign: 'center'
    }
  },
  {
    text: "Cobertura",
    value: 'cobertura_estoque',
    style: {
      borderRight: '1px solid #cecece',
      textAlign: 'center'
    }
  },
  {
    text: "Valor",
    value: 'estoque_ideal_systock',
    style: {
      textAlign: 'center'
    }
  },
  {
    text: "Cobertura",
    value: 'cobertura_ideal_systock',
    style: {
      textAlign: 'center'
    }
  },
  {
    text: "Excesso",
    value: 'excesso_atual',
    style: {
      borderRight: '1px solid #cecece',
      textAlign: 'center',
      background: '#fdebeb !important',
    }
  },
  {
    text: "Valor",
    value: 'estoque_parametrizado',
    style: {
      textAlign: 'center'
    }
  },
  {
    text: "Cobertura",
    value: 'cobertura_parametrizavel',
    style: {
      textAlign: 'center'
    }
  },
  {
    text: "Excesso",
    value: 'excesso_acima_do_parametrizado',
    style: {
      textAlign: 'center',
      background: '#fdebeb !important',
    }
  }
]


  // financeiro: [
  //   { text: 'Análise', value: 'descricao_analise' },
  //   { text: "Total de Sku's", value: 'qtde_produtos' },
  //   { text: "Saldo atual de estoque", value: 'estoque_em_preco_custo' },
  //   { text: "Cobertura estoque", value: 'cobertura_estoque' },
  //   { text: "Estoque ideal Systock", value: 'estoque_ideal_systock_em_preco_custo' },
  //   { text: "Cobertura estoque ideal Systock", value: 'cobertura_ideal_systock' },
  //   { text: "Excesso atual", value: 'excesso_atual_em_preco_custo' },
  //   { text: "Estoque parametrizado", value: 'estoque_parametrizado_em_preco_custo' },
  //   { text: "Cobertura estoque parametrizado", value: 'cobertura_parametrizavel' },
  //   { text: "Excesso acima do parametrizado", value: 'excesso_acima_do_parametrizado_em_preco_custo' },
  // ],
  // quantitativo: [
  //   { text: 'Análise', value: 'descricao_analise' },
  //   { text: "Total de Sku's", value: 'qtde_produtos' },
  //   { text: "Saldo atual de estoque", value: 'estoque' },
  //   { text: "Cobertura estoque", value: 'cobertura_estoque' },
  //   { text: "Estoque ideal Systock", value: 'estoque_ideal_systock' },
  //   { text: "Cobertura estoque ideal Systock", value: 'cobertura_ideal_systock' },
  //   { text: "Excesso atual", value: 'excesso_atual' },
  //   { text: "Estoque parametrizado", value: 'estoque_parametrizado' },
  //   { text: "Cobertura estoque parametrizado", value: 'cobertura_parametrizavel' },
  //   { text: "Excesso acima do parametrizado", value: 'excesso_acima_do_parametrizado' },
  // ]
